import styles from "@/styles/main.css?inline";

export default function Styles() {
    return <style>{styles}</style>;
}
